



































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
let uniqueId = 0;

@Component
export default class extends Vue {
  @Prop({
    default: () => {
      return `button-radio-square-${uniqueId++}`;
    }
  })
  public id!: string;
  @Prop({ default: -1 })
  public value!: number;
  @Prop({ default: -2 })
  public assignedValue!: number;

  private get active() {
    return this.assignedValue === this.localValue;
  }

  private localValue = -1;
  created() {
    this.onValueChange();
  }

  public mounted() {
    this.onValueChange();
  }

  private onChange(): void {
    this.emitChange();
  }

  @Watch("value")
  private onValueChange() {
    this.localValue = this.value;
  }

  @Emit("change")
  private emitChange(): number {
    return this.localValue;
  }
}
